import React from "react"
import styled from "@emotion/styled"

import EmailForm from "./email-form"
import LazyDisqus from "./lazy-disqus"
import InlineBio from "./inline-bio"
import { rhythm } from "utils/typography"
import mediaQuery from "utils/mediaQuery"

const BioContainer = styled.div`
  ${mediaQuery.minLarge} {
    display: none;
  }
  margin-top: ${rhythm(1)};
`

const Footer = styled.footer`
  margin-bottom: ${rhythm(2)};
`

const TagsRow = styled.div`
  font-size: 0.85rem;
`

const renderTags = (tags) => (
  <TagsRow>
    {`Tagged with: `}
    {tags.join(", ")}
  </TagsRow>
)

const PostFooter = ({ post, disqusConfig }) => (
  <>
    <Footer>
      {post.frontmatter.tags && post.frontmatter.tags.length && renderTags(post.frontmatter.tags)}
      <BioContainer>
        <InlineBio />
      </BioContainer>
      <EmailForm />
    </Footer>
    <LazyDisqus config={disqusConfig} />
  </>
)

export default PostFooter
